var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowC = function SvgRightArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.682.216.27 5.336a.893.893 0 0 0-.271.65c0 .25.099.487.271.65l5.41 5.115a.722.722 0 0 0 .784.208.834.834 0 0 0 .525-.676.897.897 0 0 0-.305-.824L1.959 5.987l4.726-4.474a.912.912 0 0 0 .23-.968C6.795.2 6.487-.018 6.154 0a.735.735 0 0 0-.472.215Z",
    fill: "#212121",
    fillRule: "nonzero"
  })));
};
export default SvgRightArrowC;